function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.81583 18.56827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Hamburger") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 30.81583,
    height: 3.04933,
    rx: 1.52467,
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7.75947,
    width: 30.81583,
    height: 3.04934,
    rx: 1.52467,
    style: {
      fill: "#828282"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15.51893,
    width: 30.81583,
    height: 3.04934,
    rx: 1.52467,
    style: {
      fill: "#828282"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/Hamburger.a2f9ea16a91a698e9ab519d9e95137ca.svg";
export { ForwardRef as ReactComponent };